import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { LIFE_CONTROL_OPTIONS } from '@/pages/Onboarding/options/LifeControl/LIFE_CONTROL_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI_Dominate/components/Title';
import { DominateFooter } from '../../components/DominateFooter';
import { useSummaryPreload } from '../../hooks/useSummaryPreload';
import { LayoutDataType } from '../../types';

import { PageStyles } from './Control.styles';

export const ScreenControl: React.FC = () => {
  const { preloadSummaryImages } = useSummaryPreload();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Control',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const lifeControl = form.watch('life_control');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['life_control']>,
  ) => {
    form.setValue('life_control', option.id);
  };

  const handleNextStep = (): void => {
    preloadSummaryImages('summary-intro');
    userService.createOrUpdate({
      onboarding_data: {
        life_control: lifeControl,
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>Are you usually in control?</OwnAiTitle>
      <IonContent>
        <OnboardingOptionsList disableTopSpacing>
          {LIFE_CONTROL_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={lifeControl === option.id}
              control={form.control}
              option={option}
              name="life_control"
              key={option.id}
              onChange={() => handleSelect(option)}
              TEST_ID={`life-control-${option.id}`}
              theme={'domination-transparent'}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      {lifeControl && (
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="Hm. We'll see how that holds up with me around"
          buttonText="I'll follow"
          variant="with-quotes"
        />
      )}
    </PageStyles>
  );
};
